/* eslint-disable import/no-restricted-paths */
import { subscribeOnAuthentification } from './subscribeOnAuthentification';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from '../../../types/referrer/store';
import { IRequestAuthenticationParameters } from '../../../../node/services/microfrontends/types';

export const requestAuthentication = createAsyncThunk<void, IRequestAuthenticationParameters, IThunkApi>(
  'authentication/requestAuthentication',
  async (parameters, _thunkApi) => {
    const { dispatch, extra } = _thunkApi;

    if (typeof window !== 'undefined') {
      const { microfrontendsAPI } = extra;

      dispatch(subscribeOnAuthentification(parameters));

      if (microfrontendsAPI) {
        microfrontendsAPI.header.openAuthModal({
          autoRefresh: false,
          viewData: parameters?.viewData || null,
        });
      }
    }
  },
);
